"use client";

import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const resultsData = [{
  metric: "+40%",
  title: "Lead generati",
  subtitle: "Acquaviva SpA",
  description: "Strategia digitale e content marketing che ha trasformato la presenza online e raddoppiato le richieste di contatto.",
  tag: "Strategia digitale"
}, {
  metric: "3x",
  title: "Fatturato",
  subtitle: "Cliente riservato",
  description: "Brand restyle completo e nuova identità visiva che ha riposizionato il brand sul mercato premium.",
  tag: "Brand Restyle"
}, {
  metric: "01",
  title: "Brand identity",
  subtitle: "Nuovo brand",
  description: "Naming, identità visiva, presenza online e strategia di lancio. Da zero a brand riconoscibile in 3 mesi.",
  tag: "Lancio brand"
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};
export default function MeasurableResults() {
  return <section id="measurableresults" className="bg-background py-24 px-6 md:px-12 lg:px-24">
      
    </section>;
}